/* DELACRUZ GRILLZ · Configurador · barra de opciones del móvil que se puede esconder (deslizar o tocar) */
(function(){
  var CSS =
  '.dlc .dlc-grab,.dlc .dlc-open{display:none}' +
  '@media (max-width:860px){' +
    'html body .dlc .dock{transition:padding .25s ease}' +
    '.dlc .dlc-grab{display:block;width:100%;height:20px;margin:-6px 0 -2px;padding:0!important;border:0;background:transparent;cursor:grab;-webkit-tap-highlight-color:transparent;touch-action:none}' +
    '.dlc .dlc-grab::before{content:"";display:block;width:40px;height:5px;margin:0 auto;border-radius:3px;background:rgba(255,255,255,.38);transition:background .2s,width .2s}' +
    '.dlc .dlc-grab:active::before{background:rgba(255,255,255,.6);width:48px}' +
    '.dlc .dlc-open{align-items:center;gap:6px;flex:none;height:40px;padding:0 14px 0 12px;border:.5px solid rgba(255,255,255,.14);border-radius:999px;background:rgba(255,255,255,.1);color:#f5f5f7;font:600 14px -apple-system,BlinkMacSystemFont,"SF Pro Text",Inter,system-ui,sans-serif;letter-spacing:-.01em;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
    '.dlc .dlc-open:active{transform:scale(.96)}' +
    '.dlc .dlc-open svg{width:14px;height:14px}' +
    '.dlc .dock.dlc-min #dlc-docksub,.dlc .dock.dlc-min #dlc-dockstyles,.dlc .dock.dlc-min #dlc-dockmetals{display:none!important}' +
    '.dlc .dock.dlc-min .dlc-open{display:inline-flex}' +
    '.dlc .dock.dlc-min .dlc-grab{margin-bottom:-4px}' +
    '.dlc .dock.dlc-anim>*:not(.dlc-grab){animation:dlcdockin .32s cubic-bezier(.32,.72,0,1) both}' +
    '@keyframes dlcdockin{from{opacity:0;transform:translateY(14px)}}' +
  '}' +
  '@media (prefers-reduced-motion:reduce){.dlc .dock.dlc-anim>*{animation:none!important}}';

  function ready(fn){
    var tries = 0;
    (function wait(){
      var dock = document.getElementById('dlc-dock'), row = document.getElementById('dlc-dockrow');
      if (dock && row) return fn(dock, row);
      if (++tries < 100) setTimeout(wait, 100);
    })();
  }

  ready(function(dock, row){
    if (dock.querySelector('.dlc-grab')) return;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

    var grab = document.createElement('button');
    grab.type = 'button'; grab.className = 'dlc-grab';
    grab.setAttribute('aria-label', 'Ocultar opciones'); grab.setAttribute('aria-expanded', 'true');
    dock.insertBefore(grab, dock.firstChild);

    var open = document.createElement('button');
    open.type = 'button'; open.className = 'dlc-open';
    open.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 15l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>Opciones';
    open.setAttribute('aria-label', 'Mostrar opciones');
    row.insertBefore(open, row.firstChild);

    function set(min){
      dock.classList.toggle('dlc-min', min);
      grab.setAttribute('aria-expanded', String(!min));
      grab.setAttribute('aria-label', min ? 'Mostrar opciones' : 'Ocultar opciones');
      if (!min){ dock.classList.remove('dlc-anim'); void dock.offsetWidth; dock.classList.add('dlc-anim'); }
    }
    grab.addEventListener('click', function(){ set(!dock.classList.contains('dlc-min')); });
    open.addEventListener('click', function(){ set(false); });

    /* Deslizar hacia abajo para esconder, hacia arriba para volver a abrir */
    var y0 = null, x0 = 0, moved = false;
    dock.addEventListener('touchstart', function(e){
      var t = e.touches[0]; y0 = t.clientY; x0 = t.clientX; moved = false;
    }, {passive:true});
    dock.addEventListener('touchmove', function(e){
      if (y0 === null || moved) return;
      var t = e.touches[0], dy = t.clientY - y0, dx = t.clientX - x0;
      if (Math.abs(dy) < 34 || Math.abs(dy) < Math.abs(dx) * 1.3) return;
      var min = dock.classList.contains('dlc-min');
      if (dy > 0 && !min){ moved = true; set(true); }
      else if (dy < 0 && min){ moved = true; set(false); }
    }, {passive:true});
    dock.addEventListener('touchend', function(){ y0 = null; }, {passive:true});
  });
})();
